import { MasterDataType } from "@type/HRM/master-data";
export interface OptionType {
  label: string;
  value: number | string;
  [key: string]: any;
}

export const getConvertedMasterData = (
  masterData: MasterDataType[],
  language: string | null | undefined,
  gender?: boolean,
): OptionType[] => {
  const LANGUAGE = {
    BANGLA: "bn",
    ENGLISH: "en",
  };

  let convertedData = [] as OptionType[];

  masterData &&
    masterData.forEach((item: MasterDataType) => {
      let selectOptions = {} as OptionType;
      selectOptions.label =
        language === LANGUAGE.BANGLA
          ? item.nameBn || item.bn_name
          : item.nameEn || item.name;
      if (gender) {
        selectOptions.value = item.idToString;
        selectOptions.id = item.idToString;
      } else selectOptions.value = item.id;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) =>
    String(a.label).localeCompare(String(b.label)),
  );
};
